
import {useContext} from "react"
import ToastContext from "../contexts/ToastContext"

export default function Toast(){
    const [toastContext]=useContext(ToastContext)

    // Determine toast type for styling
    let typeClass = ""
    if(["error","domain_error","pay_error","pay_invalid_data","pay_invalid_card_number","pay_invalid_expiry_date","pay_invalid_security_code"].includes(toastContext.toast)){
        typeClass = " toast-error"
    } else if(["success","saved","created_m","created_f","refunded","liquidated","cuit_verified","message_sent","ticket_created","links_imported","link_copied","link_sent","access_token_copied","activated","unblocked"].includes(toastContext.toast)){
        typeClass = " toast-success"
    } else if(["pay_error","pay_invalid_data","pay_invalid_card_number","pay_invalid_expiry_date","pay_invalid_security_code"].includes(toastContext.toast)){
        typeClass = " toast-alt"
    }

    let message = null
    // Predefined messages
    switch(toastContext.toast) {
        case "saved": message = "¡Cambios guardados!"; break;
        case "created_m": message = "¡Creado!"; break;
        case "created_f": message = "¡Creada!"; break;
        case "removed": message = "Elemento eliminado."; break;
        case "deactivated": message = "Usuario desactivado."; break;
        case "blocked": message = "Usuario bloqueado."; break;
        case "activated": message = "Usuario activado."; break;
        case "unblocked": message = "Usuario desbloqueado."; break;
        case "ticket_created": message = "¡Solicitud enviada!"; break;
        case "message_sent": message = "¡Mensaje enviado!"; break;
        case "file_not_allow": message = "Tipo de archivo no permitido."; break;
        case "links_imported": message = "¡Links creados desde el archivo!"; break;
        case "link_copied": message = "¡Enlace copiado!"; break;
        case "link_sent": message = "¡Enlace enviado!"; break;
        case "access_token_copied": message = "¡Clave copiada!"; break;
        case "refunded": message = "¡Devolución concretada!"; break;
        case "liquidated": message = "¡Liquidación registrada!"; break;
        case "fraud_updated": message = "Evaluación de fraude actualizada."; break;
        case "fraud_update_error": message = "No se pudo actualizar la evaluación de fraude."; break;
        case "pay_error":
            if(toastContext.params && toastContext.params["errorCode"]) {
                switch(toastContext.params["errorCode"]) {
                    case "CLIENT_300": message = "Revisá todos los datos..."; break;
                    case "CLIENT_301": message = "Número de tarjeta incorrecto..."; break;
                    case "CLIENT_302": message = "Fecha de vencimiento incorrecta..."; break;
                    case "CLIENT_303": message = "Código de seguridad incorrecto..."; break;
                    case "CLIENT_304": message = "Completá todos los campos..."; break;
                    case "PSP_023": message = "Fecha de vencimiento no válida..."; break;
                    case "PSP_024": case "PSP_509": message = "Código de seguridad no válido..."; break;
                    case "PSP_026": case "PSP_526": case "PSP_527": case "PSP_528": case "PSP_529": case "PSP_530": case "PSP_531": case "PSP_532": case "PSP_533": message = "Número de tarjeta no válido..."; break;
                    case "PSP_021": case "PSP_519": case "PSP_606": message = "Moneda desconocida..."; break;
                    case "PSP_020": case "PSP_040": case "PSP_506": case "PSP_583": message = "El monto no es válido..."; break;
                    case "PSP_665": case "PSP_666": case "PSP_667": case "PSP_668": message = "Revisá número y tipo de documento..."; break;
                    default: message = "Algo no anduvo bien...";
                }
            } else {
                message = "Algo no anduvo bien...";
            }
            break;
        case "cbu_empty": message = "Completá el CBU o alias..."; break;
        case "cuit_empty": message = "Completá el CUIT del/la titular..."; break;
        case "cuit_invalid": message = "El CUIT no es válido..."; break;
        case "debin_failed": message = "CBU, alias o CUIT incorrecto..."; break;
        case "webpos_empty": message = "Completá al menos un concepto..."; break;
        case "webpos_select_point": message = "Seleccioná un punto de cobro..."; break;
        case "webpos_expired_1": message = `¡Vencido el ${toastContext.params["date"]}! (1° vencimiento)`; break;
        case "webpos_expired_2": message = `¡Vencido el ${toastContext.params["date"]}! (2° vencimiento)`; break;
        case "cuit_verified": message = "¡CUIT verificado!"; break;
        case "cuit_unverified": message = "CUIT no encontrado..."; break;
        case "image_not_uploaded": message = "No se pudo cambiar la imagen..."; break;
        default:
            // If params is a string, show it (for domain_error, etc)
            if(typeof toastContext.params === "string" && toastContext.params.length > 0) {
                message = toastContext.params
            } else if(toastContext.params && toastContext.params.message) {
                message = toastContext.params.message
            } else {
                message = null
            }
    }

    return (
        <div id="toast" className={`toast noselect${typeClass}`.trim()}>
            <div className="toast-box">
                {message && <div>{message}</div>}
            </div>
        </div>
    )
}
